export default "__VITE_ASSET__c8231928__"